<div class="row-container">
    <div>
        0 träffar, vill du genomföra en utökad sökning?
    </div>
    <div>
        <rask-button color="tertiary" class="float-end" (mousedown)="$event.preventDefault()" (click)="extendedNavetSearch($event)" icon="fas fa-search">Utökad sökning</rask-button>
    </div>
</div>